import { render, staticRenderFns } from "./OurSolutionPopup.vue?vue&type=template&id=5b908e78&scoped=true"
import script from "./OurSolutionPopup.vue?vue&type=script&lang=js"
export * from "./OurSolutionPopup.vue?vue&type=script&lang=js"
import style0 from "./OurSolutionPopup.vue?vue&type=style&index=0&id=5b908e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b908e78",
  null
  
)

export default component.exports